import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import LoginModal1 from '../../components/Header/LoginModal1';
import CommonSignUpModal from '../../components/Header/CommonSignUpModal';
import styled from 'styled-components';

const PageWrapper = styled.div`
  //padding: 40px 0;
  display: flex;
  justify-content: center;
  width: 100%;
  
  & > div > div {
    max-height: none !important;
    height: auto !important;
  }
`;

const LoginPage = () => {
  const [isSignUpModal, setSignUpModal] = useState(false);
  const history = useHistory();

  useEffect(() => {
    document.body.style.overflow = 'auto';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  const toggleLogin = () => {
    setSignUpModal(!isSignUpModal);
  };

  return (
    <PageWrapper>
      {!isSignUpModal ? (
        <LoginModal1 
          isSignUpModal={isSignUpModal}
          setLoginToggle={() => history.push('/')}
          loginToggle={true}
          toggleLogin={toggleLogin}
        />
      ) : (
        <CommonSignUpModal 
          isSignUpModal={isSignUpModal}
          setSignUpModal={setSignUpModal}
          toggleLogin={toggleLogin}
        />
      )}
    </PageWrapper>
  );
};

export default LoginPage;
